import { orpc } from '@/api/rpc/client';
import { ProductModule } from '@erp/shared-types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useGetModuleConfigs() {
  return useQuery(orpc.org.config.modules.getModuleConfigs.queryOptions());
}

export function useGetModuleConfig(module: ProductModule) {
  return useQuery(
    orpc.org.config.modules.getModuleConfig.queryOptions({ input: { module } }),
  );
}

export function useCreateOrUpdateModuleConfig() {
  const queryClient = useQueryClient();

  return useMutation({
    ...orpc.org.config.modules.createOrUpdateModuleConfig.mutationOptions(),
    onSuccess: () => {
      // Invalidate and refetch module configs when a mutation succeeds
      queryClient.invalidateQueries({
        queryKey:
          orpc.org.config.modules.getModuleConfigs.queryOptions().queryKey,
      });
    },
  });
}
